/**
 * Aplaza ejecución de callbacks de notificación del socket KPI cuando hay grabación de audio activa,
 * para no competir con RecordRTC/getUserMedia en el hilo principal.
 */
let deferDepth = 0
const queuedTasks = []

export function beginDeferKpiNotifications () {
  deferDepth++
}

export function endDeferKpiNotifications () {
  deferDepth = Math.max(0, deferDepth - 1)
  if (deferDepth === 0) {
    flushQueuedKpiNotifications()
  }
}

export function runKpiNotification (task) {
  if (deferDepth > 0) {
    queuedTasks.push(task)
    return
  }
  task()
}

function flushQueuedKpiNotifications () {
  const tasks = queuedTasks.splice(0, queuedTasks.length)
  tasks.forEach((task, index) => {
    window.setTimeout(() => {
      try {
        task()
      } catch (e) {
        console.error('[socketKpiNotificationDefer]', e)
      }
    }, index * 80)
  })
}
